import { BaseService } from "./base.service";
import { ITransactionType } from "models/TransactionTypeModel";

class TransactionTypeServiceInternal extends BaseService {
	getTransactionTypeList = async (): Promise<ITransactionType[]> =>
		this.callApi<ITransactionType[]>(
			`TransactionType/GetTransactionTypeList`,
			"GET"
		);
}

export const TransactionTypeService = new TransactionTypeServiceInternal();
